import React, { useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Loading from '../common/Loading';
import { dashboardService, commonService } from '../../services';

const ClaimStatusCountTracker = ({ filter }) => {

    const claimDaysArray = [
        {
            title: "Less than 20 days",
            purpose: "0-19",
            key: "lessThan20Days"
        }, {
            title: "20 - 30 days",
            purpose: "20-30",
            key: "between20And30Days"

        }, {
            title: "More than 30 days",
            purpose: "31-0",
            key: "moreThan30Days"
        }
    ];

    const [claimCounterData, setClaimCounterData] = useState({
        initiated: 0,
        inProgress: 0,
        settled: 0,
        partiallySettled: 0,
        withDrawn: 0,
        drafted: 0
    });


    const [isLoading, setIsLoading] = useState(false);
    const [isClaimCountLoading, setIsClaimCountLoading] = useState(false);
    const [claimStatusDropdownList, setClaimStatusDropdownList] = useState([])
    const [activeBtn, setActiveBtn] = useState(claimDaysArray[0]?.key);

    const fetchStatus = useCallback(async () => {
        const statusResponse = await commonService.dropdown({ moduleName: "Status", id: 0, purpose: `status_1`, })
        if (statusResponse?.data?.isSuccess) {
            let statusList = statusResponse.data.data
            let allClaimStatus = [{ name: "All Claim Status", id: 0 }, ...statusList]
            setClaimStatusDropdownList(allClaimStatus)
        }
    }, [])

    const fetchClaimCountData = useCallback(async () => {
        setIsClaimCountLoading(true);
        const claimCounterDataResponse = await dashboardService.fetchClaimDaysData({
            ...filter,
            purpose: claimDaysArray.find((claim) => claim.key === activeBtn)?.purpose
        });
        if (claimCounterDataResponse?.isSuccess) {
            setClaimCounterData(claimCounterDataResponse?.data?.[0]);
        }
        setIsClaimCountLoading(false);
        setIsLoading(false)
    }, [activeBtn, filter]);

    useEffect(() => {
        setIsLoading(true)
    }, [filter]);

    useEffect(() => {
        const fetchList = async () => {
            await fetchClaimCountData()
        }
        fetchList()
    }, [activeBtn, filter]);

    useEffect(() => {
        const fetchList = async () => {
            await fetchStatus()
        }
        fetchList()
    }, [])

    return (
        <div>
            <div className='wrapperclaim_box'>
                <h2 className='wrapperclaim_boxTitle'>Claim Status Timeline Wise</h2>
                <div className='d-flex justify-content-center flex-row plocis_and_claim_amount_wrap  text-center'>

                    {claimDaysArray && claimDaysArray.length > 0 &&
                        claimDaysArray.map((claimDay) => {
                            return <div className={`fieldArrayBox days_clculate plocis_claim_amountbox ${claimDay?.key === activeBtn ? "plocis_claim_amountboxactive" : ""} mb-4`}
                                onClick={() => {
                                    setActiveBtn(claimDay?.key);
                                }}
                            >
                                <div>
                                    <label className="top_box_title">
                                        {claimDay?.title}
                                    </label>
                                </div>
                                <div className='top_box_count'>
                                    {!isLoading ? (claimCounterData?.[claimDay?.key] || 0) : <Loading isHeightReq={false} />}
                                </div>
                            </div>
                        })
                    }
                </div>

                <div className='d-flex justify-content-center row plocis_and_claim_amount_wrap  text-center'>
                    <div className="fieldArrayBox days_calculate_boxiniteated boxiniteated_lgrey mb-4">
                        <Link to={{
                            pathname: "/External/raise-claim",
                        }}
                            style={{ textDecoration: 'none' }}
                            state={{
                                claimStatusId: claimStatusDropdownList.find((status) => status.name === "Drafted")?.id,
                                claimStatusName: "Drafted",
                                purpose: claimDaysArray.find((days) => days.key === activeBtn)?.purpose
                            }}
                        >
                            <div>
                                <label className="top_box_title">
                                    Draft
                                </label>
                            </div>
                            <div className='top_box_count'>
                                {!isClaimCountLoading ? claimCounterData?.drafted || 0 : <Loading isHeightReq={false} />}
                            </div>
                        </Link>
                    </div>
                    <div className="fieldArrayBox days_calculate_boxiniteated boxiniteated_red mb-4">
                        <Link to={{
                            pathname: "/External/raise-claim",
                        }}
                            style={{ textDecoration: 'none' }}
                            state={{
                                claimStatusId: claimStatusDropdownList.find((status) => status.name === "Initiated")?.id,
                                claimStatusName: "Initiated",
                                purpose: claimDaysArray.find((days) => days.key === activeBtn)?.purpose
                            }}
                        >
                            <div>
                                <label className="top_box_title">
                                    Initiated
                                </label>
                            </div>
                            <div className='top_box_count'>
                                {!isClaimCountLoading ? claimCounterData?.initiated || 0 : <Loading isHeightReq={false} />}
                            </div>
                        </Link>
                    </div>


                    <div className="fieldArrayBox days_calculate_boxiniteated boxiniteated_orange  mb-4">
                        <Link to={{
                            pathname: "/External/raise-claim",
                        }}
                            style={{ textDecoration: 'none' }}
                            state={{
                                claimStatusId: claimStatusDropdownList.find((status) => status.name === "In Progress")?.id,
                                claimStatusName: "In Progress",
                                purpose: claimDaysArray.find((days) => days.key === activeBtn)?.purpose
                            }}
                        >
                            <div>
                                <label className="top_box_title">
                                    In Progress
                                </label>
                            </div>
                            <div className='top_box_count'>
                                {!isClaimCountLoading ? claimCounterData?.inProgress || 0 : <Loading isHeightReq={false} />}
                            </div>
                        </Link>
                    </div>

                    <div className="fieldArrayBox days_calculate_boxiniteated boxiniteated_yellow  mb-4">
                        <Link to={{
                            pathname: "/External/raise-claim",
                        }}
                            style={{ textDecoration: 'none' }}
                            state={{
                                claimStatusId: claimStatusDropdownList.find((status) => status.name === "Partially Settled")?.id,
                                claimStatusName: "Partially Settled",
                                purpose: claimDaysArray.find((days) => days.key === activeBtn)?.purpose
                            }}
                        >
                            <div>
                                <label className="top_box_title" style={{ color: 'black' }}>
                                    Partially Settled
                                </label>
                            </div>
                            <div className='top_box_count' style={{ color: 'black' }}>
                                {!isClaimCountLoading ? claimCounterData?.partiallySettled || 0 : <Loading isHeightReq={false} />}
                            </div>
                        </Link>
                    </div>

                    <div className="fieldArrayBox days_calculate_boxiniteated boxiniteated_green mb-4">
                        <Link to={{
                            pathname: "/External/raise-claim",
                        }}
                            style={{ textDecoration: 'none' }}
                            state={{
                                claimStatusId: claimStatusDropdownList.find((status) => status.name === "Settled")?.id,
                                claimStatusName: "Settled",

                                purpose: claimDaysArray.find((days) => days.key === activeBtn)?.purpose
                            }}
                        >
                            <div>
                                <label className="top_box_title">
                                    Settled
                                </label>
                            </div>
                            <div className='top_box_count'>
                                {!isClaimCountLoading ? claimCounterData?.approved || 0 : <Loading isHeightReq={false} />}
                            </div>
                        </Link>
                    </div>

                    <div className="fieldArrayBox days_calculate_boxiniteated boxiniteated_grey mb-4">
                        <Link to={{
                            pathname: "/External/raise-claim",
                        }}
                            style={{ textDecoration: 'none' }}
                            state={{
                                claimStatusId: claimStatusDropdownList.find((status) => status.name === "Withdrawn")?.id,
                                claimStatusName: "Withdrawn",
                                purpose: claimDaysArray.find((days) => days.key === activeBtn)?.purpose
                            }}
                        >
                            <div>
                                <label className="top_box_title">
                                    Withdrawn
                                </label>
                            </div>
                            <div className='top_box_count'>
                                {!isClaimCountLoading ? claimCounterData?.withDrawn || 0 : <Loading isHeightReq={false} />}
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ClaimStatusCountTracker